<template>
  <div class="detail-container">
    <el-descriptions border :column="1" :labelStyle="{ width: '120px' }">
      <el-descriptions-item label="学号">{{
        detailInfo.studentNo
      }}</el-descriptions-item>
      <el-descriptions-item label="身份证号">{{
        detailInfo.idCard
      }}</el-descriptions-item>
      <el-descriptions-item label="姓名">{{
        detailInfo.studentName
      }}</el-descriptions-item>
      <el-descriptions-item label="学院"
        >{{ detailInfo.collegeName }}
      </el-descriptions-item>
      <el-descriptions-item label="专业">{{
        detailInfo.majorName
      }}</el-descriptions-item>
      <el-descriptions-item label="班级">{{
        detailInfo.className
      }}</el-descriptions-item>
      <el-descriptions-item label="贷款金额">{{
        detailInfo.loanAmount
      }}</el-descriptions-item>
      <el-descriptions-item label="回执校验码">{{
        detailInfo.receiptCode
      }}</el-descriptions-item>
      <el-descriptions-item label="贷款图片">
        <div
          class="evidence-img-item img-item"
          v-for="(item, index) in detailInfo.pictureUrl"
          :key="index"
        >
          <el-image
            style="width: 100px; height: 100px"
            z-index="9999"
            :src="item"
            :preview-src-list="detailInfo.pictureUrl"
          >
          </el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SUCCESS_CODE: "",
    };
  },
  props: {
    detailInfo: {
      type: Object,
      default: {},
    },
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {},
  methods: {},
};
</script>
